import React from "react";
import {Grid, MenuItem, Select, TextField} from "@mui/material";
import {ReactSession} from "react-client-session";

class FiltriTotali extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            condizione: "Scelta condizione",
            importo: "",
        }
        this.idmagazzino = ReactSession.get("idmagazzino");
    }

    componentDidMount() {
        this.handleChange = this.handleChange.bind(this);
    }


    handleChange(event, provenienza) {
        if (provenienza === 'condizione') {
            this.props.handleChangeTotali(event.target.value, this.state.importo);
            this.setState({condizione: event.target.value});
        }
        if (provenienza === 'importo') {
            this.props.handleChangeTotali(this.state.condizione, event.target.value);
            this.setState({importo: event.target.value});
        }
    }


    render() {
        return (
            <div className="elemento">
                <Grid container direction="row" spacing={3}>
                    <Grid item>
                        <Select
                            labelId="demo-simple-select-label"
                            id="filtroRep"
                            value={this.state.condizione}
                            label=''
                            onChange={(e) => this.handleChange(e, "condizione")}>
                            <MenuItem value={'Scelta condizione'}>Scelta condizione</MenuItem>
                            <MenuItem value={'<'}>Minore</MenuItem>
                            <MenuItem value={'<='}>Minore o uguale</MenuItem>
                            <MenuItem value={'='}>Uguale</MenuItem>
                            <MenuItem value={'!='}>Diverso</MenuItem>
                            <MenuItem value={'>'}>Maggiore</MenuItem>
                            <MenuItem value={'>='}>Maggiore o uguale</MenuItem>
                        </Select>
                    </Grid>
                    <Grid item>
                        <TextField
                            label="Valore vendita"
                            value={this.state.importo}
                            defaultValue={this.state.importo}
                            onChange={(e) => this.handleChange(e, "importo")}/>
                    </Grid>
                </Grid>
            </div>
        )

    }
}

export default FiltriTotali


